var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"artist-legal-line has-text-grey-light py-3 px-5"},[_c('div',{staticClass:"container"},[(_vm.artist)?_c('p',{staticClass:"has-text-grey-light"},[_vm._v("\n      "+_vm._s(_vm.artist.nickname)),_c('br'),_vm._v(" "),_c('nuxt-link',{attrs:{"to":_vm.localePath({
          name: 'id-profile-imprint',
          params: { id: _vm.artist.urlAlias }
        })}},[_vm._v("\n        "+_vm._s(_vm.$t('imprint'))+"\n      ")]),_c('br'),_vm._v(" "),(_vm.hasTOS)?_c('nuxt-link',{attrs:{"to":_vm.localePath({
          name: 'id-profile-tos',
          params: { id: _vm.artist.urlAlias }
        })}},[_vm._v("\n        "+_vm._s(_vm.$t('tos'))+"\n      ")]):_vm._e(),_c('br'),_vm._v(" "),(_vm.hasPrivacy)?_c('nuxt-link',{attrs:{"to":_vm.localePath({
          name: 'id-profile-privacy',
          params: { id: _vm.artist.urlAlias }
        })}},[_vm._v("\n        "+_vm._s(_vm.$t('privacy'))+"\n      ")]):_vm._e()],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }